module.exports = "/images/vessel-11.jpg";